import React, {Component} from 'react'
import UserProfile from '../Configuration/UserProfile'
import {Helmet} from "react-helmet";
import ReactGA, { pageview } from 'react-ga';
import * as config from '../Configuration/Config.js'
import {isMobile,browserName,browserVersion, osName,osVersion} from 'react-device-detect';
//import * as config from '../Configuration/Config'
import windowSize from 'react-window-size';
import { Redirect } from 'react-router-dom';
import uuid from 'uuid';
import Sidebar from '../Shared/Sidebar';
import * as pbi from 'powerbi-client';

class Header extends Component {
    constructor() {
        super()

        this.handleFullscreen = this.handleFullscreen.bind(this);       

        this.state = {
            homeUrl: '/',
            is_loaded: false,
            customer: null,
            menus: null
        }
    }
    
    componentDidMount() {
        ReactGA.initialize('UA-26101514-2', { debug: true });
        ReactGA.pageview(window.location.pathname);
        var that = this;
        let uri = config.getUriPath('users/menu' );
        if(sessionStorage.getItem("homeurl") !== null)        
        {  
           that.fetchCustomer(sessionStorage.getItem("homeurl"));
        }
        else
        {
            fetch(uri, {
                method: 'get',
                headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                that.setState({error: "Server Error, please try again shortly"})
                }
                return response.json();
            })
            .then(function(data) {
                const homeData = data.filter((item) => item.title === "Home");
                let homeUrl = '/';
                if(homeData.length > 0) {
                    sessionStorage.setItem("homeurl",homeData[0].url);
                    homeUrl = homeData[0].url;
                }
                that.fetchCustomer(homeUrl);
                
            });
        }
    } 
    
    fetchCustomer(homeUrl)
    {
        var that = this;
        this.profile = new UserProfile();        
        var varCustomerId = this.profile.CustomerId();
        console.log('fetchCustomer cid: ' + varCustomerId);

        if(varCustomerId !== 'ACUMEN')
        {
            let uri = config.getUriPath('customers/' + varCustomerId)
            fetch(uri, {
                method: 'get',
                headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {                        
                that.fetchMenu(homeUrl,data);
            });
        }
        else
        {
            that.fetchMenu(homeUrl,null);
        }              
    }

    fetchMenu(homeurl,customer)
    {
        var that = this;
        if(sessionStorage.getItem("mmenu") !== null)        
        {  
           console.log('mmenu from session')
           that.setState({homeUrl:homeurl,is_loaded: true,customer:customer, menus:JSON.parse(sessionStorage.getItem("mmenu"))});
        }
        else
        {
            this.profile = new UserProfile();        
            var varUserId = this.profile.UserId();
            
            let uri = config.getAcumenAPIURL('api/user/menu/' + varUserId);        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix()); 

            var that = this;
            fetch(uri, {
                method: 'get',
                headers: myHeaders
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {
                //console.log('user/menu: ' + data.menu);
                sessionStorage.setItem("mmenu",JSON.stringify(data.menu));
                that.setState({homeUrl:homeurl,is_loaded: true,customer:customer, menus:data.menu});
            });   
        }     
    }
    
    handleFullscreen(event)
    {
        let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        var reportContainer = document.getElementById('rptContainer');          
        var report = powerbi.get(reportContainer);
        report.fullscreen();
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div>Loading...</div>
        }

        this.profile = new UserProfile();
        //const isAcumenAdmin = this.profile.IsAcumenAdmin();
        //const isCustomerAdmin = this.profile.IsCustomerAdmin();
        //const isAuthenticated = config.AuthManager.isAuthenticated();
        const title = this.props.title;
        const customer = this.state.customer;
        const mmenu = this.state.menus;
        
        var userDefaultPage = this.profile.DefaultPage();
        console.log("Default Page: " + userDefaultPage);
        if(this.profile.IsAcumenAdmin() == false)
        {
            if ( window.location.pathname === '/')
            {
                if(userDefaultPage != null) 
                {
                    console.log('redirect to: ' + userDefaultPage);                    
                    return <Redirect to={userDefaultPage} />
                }
            }
        }

        var IsVizPage = false;
        if(window.location.href.includes('visualizations/') || window.location.href.includes('dashboards/'))
        {
            IsVizPage = true;
        }
        

        var varPageEvent = '';
        var varUserIP = '';
        var varUserEmail = '';        
        var varCurrentPage = '';
        var varCurrentDateTime = '';
        var varIsAcumenAdmin = '';
        var varIsCustomerAdmin = '';
        var varCustomerId = '';
        var varUserId = '';
        var varIsMobile = '';
        var varScreenWidth = '';
        var varScreenHeight = '';
        var varBrowserName = '';
        var varBrowserVersion = '';
        var varOSName = '';
        var varOSVersion = '';
        var varSessionID = '';
        
        //PageEvent
        var varPageEvent = 'PAGEVIEW';
        //ip address
        if(sessionStorage.getItem("session_ipaddress") === null)        
        {
            fetch('https://api.ipify.org').then(response => response.text()).then((data)=>{sessionStorage.setItem('session_ipaddress',data)});    
            varUserIP =  sessionStorage.getItem("session_ipaddress");     
        }
        else
        {            
            varUserIP =  sessionStorage.getItem("session_ipaddress");
        }        
        //email address           
        varUserEmail = this.profile.Email();
        //CurrentPage
        varCurrentPage = window.location.href;
        //CurrentDateTime
        varCurrentDateTime = Date.now();
        //IsAcumenAdmin
        varIsAcumenAdmin = this.profile.IsAcumenAdmin();
        //IsCustomerAdmin
        varIsCustomerAdmin = this.profile.IsCustomerAdmin();
        //CustomerId
        varCustomerId = this.profile.CustomerId();
        //UserId
        varUserId = this.profile.UserId();
        //IsMobile
        varIsMobile = isMobile;
        //varScreenWidth
        varScreenWidth = window.innerWidth;
        //varScreenHeight
        varScreenHeight = window.innerWidth;
        varBrowserName = browserName;
        varBrowserVersion = browserVersion;
        varOSName = osName;
        varOSVersion = osVersion;        
        
        if(sessionStorage.getItem("session_id") === null)        
        {           
            sessionStorage.setItem('session_id',uuid.v4());  
            varSessionID = sessionStorage.getItem("session_id");     
        }
        else
        {            
            varSessionID =  sessionStorage.getItem("session_id");
        }                
        console.log('session_id: ' + varSessionID);    

        //console.log('varPageEvent: ' + varPageEvent);
        //console.log('varUserIP: ' + varUserIP);
        //console.log('varUserEmail: ' + varUserEmail);       
        //console.log('varCurrentPage: ' + varCurrentPage);
        //console.log('varCurrentDateTime: ' + varCurrentDateTime );
        //console.log('varIsAcumenAdmin: ' + varIsAcumenAdmin);
        //console.log('varIsCustomerAdmin: ' + varIsCustomerAdmin);
        //console.log('varCustomerId: ' + varCustomerId);
        //console.log('varUserId: ' + varUserId);
        //console.log('varIsMobile: ' + varIsMobile);
        //console.log('varScreenWidth: ' + varScreenWidth);
        //console.log('varScreenHeight: ' + varScreenHeight);
        //console.log('varBrowserName: ' + varBrowserName);
        //console.log('varBrowserVersion: ' + varBrowserVersion);
        //console.log('varOSName: ' + varOSName);
        //console.log('varOSVersion: ' + varOSVersion);

        var UserMetric = {            
            "PageEvent" : varPageEvent,
            "UserIP" : varUserIP,
            "UserEmail" : varUserEmail,
            "CurrentPage" : varCurrentPage,
            "CurrentDateTime" : varCurrentDateTime,
            "IsAcumenAdmin" : varIsAcumenAdmin,
            "IsCustomerAdmin" : varIsCustomerAdmin,
            "CustomerId" : varCustomerId,
            "UserId" : varUserId,
            "IsMobile" : varIsMobile,
            "ScreenWidth" : varScreenWidth,
            "ScreenHeight" : varScreenHeight,
            "BrowserName" : varBrowserName,
            "BrowserVersion" : varBrowserVersion,
            "OSName" : varOSName,
            "OSVersion" : varOSVersion,
            "SessionID" : varSessionID
        };

        if (this.state.is_loaded === true)
        {
            let method = 'post';
            const uri = config.getUriPath('usermetric');
            const h = config.ApiHeaders();        
            fetch(uri, {
                method: method,
                headers: h,
                body: JSON.stringify(UserMetric)
            }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }              
            });            
        }              

        var logourl = '/logos/white.png';
        /*
        if(sessionStorage.getItem("logourl") !== null)        
        {
            logourl = sessionStorage.getItem("logourl");         
        }
        else
        {
            if (this.state.is_loaded === true)
            {
                if(this.profile.IsAcumenAdmin() == false)
                {
                    //console.log("Default Page: " + this.profile.DefaultPage());        
                    //console.log("customer.customer_custom_logo: " + customer.customer_custom_logo);
                    if(customer.customer_custom_logo !== undefined && customer.customer_custom_logo !== '' && customer.customer_custom_logo !== null)
                    {
                        logourl = '/logos/' + varCustomerId.replace(/[^0-9a-z]/gi, '') + "/" + customer.customer_custom_logo;
                        sessionStorage.setItem("logourl",logourl); 
                    }
                }
            }
        }
        console.log("logourl: " + logourl);
        */
       
        var username = this.profile.Email();    
        if (isMobile) {
            username = "";
        }             
       
        var maincount = 0;
        var subcount = 0;
        maincount = mmenu.length;        
        for(var item of mmenu){
            subcount = subcount + item.subitems.length;
        }
        //console.log('maincount: ' + maincount.toString());
        //console.log('subcount: ' + subcount.toString());

        var mmoduleclass = 'flex-container-std';
        var mmoduleitemclass = 'flex-container-item-std';

        if (maincount > 10 || subcount > 40)
        {
            mmoduleclass = 'flex-container-lrg';
            mmoduleitemclass = 'flex-container-item-lrg';
        }

        if (maincount <= 4 && subcount <= 15)
        {
            mmoduleclass = 'flex-container-sml';
            mmoduleitemclass = 'flex-container-item-sml';
        }

        return <header className="fixedheader">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{title}</title>                        
                    </Helmet>

                    <div className="grid-wrapper">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    <a href={'/'}>                                        
                                        <img className="" src={logourl} alt="Logo"/>
                                    </a>
                                </div>
                                {isMobile == false &&
                                <div className="topmenu">
                                    <div className="megamenu">
                                        <button className="dropbtn-modules">Modules&nbsp;<i className="fa fa-caret-down"></i></button>
                                        <div className="modules-menu">
                                            <div class={mmoduleclass}>                                        
                                            {
                                                mmenu.map((menuitem) => (
                                                    
                                                        <div className={mmoduleitemclass}>
                                                            <div className="ModuleMIHead"> 
                                                            {menuitem.url.length > 0 ? <a href={menuitem.url} target={menuitem.target}>{menuitem.title}</a> : menuitem.title}
                                                            </div>
                                                            {
                                                                menuitem.subitems.map((subitem) => {
                                                                    return (
                                                                        <div className="ModuleMISub"><a href={subitem.url} target={subitem.target}>{subitem.title}</a></div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    
                                                    ))
                                            }
                                            </div>
                                        </div>                                    
                                    </div> 
                                    <a href="https://a2acumen.atlassian.net/servicedesk/customer/portal/5" target="_blank"><div className="dropbtn-support">Support</div></a>

                                    <div className="megamenu">
                                        <button className="dropbtn-community">Community&nbsp;<i className="fa fa-caret-down"></i></button>
                                        <div className="community-menu">
                                            <div className="flex-container-sml">
                                                <div className="flex-container-item-sml">
                                                    {/*
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/communities/community-home/librarydocuments?LibraryKey=830f1f1b-53a3-45a0-8ee0-54fdf24534b1" target="_blank">Knowledge Base</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/participate/postmessage?ReturnUrl=https%3a%2f%2fcommunity.getacumen.com%2fbrowse%2fallrecentposts" target="_blank">Post in the Community</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/blogs" target="_blank">Release Notes</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/ideation-home" target="_blank">Product Ideas</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/roadmap" target="_blank">Roadmap</a></div>
                                                    */}
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/home" target="_blank">Community Home</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/participate/postmessage" target="_blank">Start a Discussion</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/communities/community-home/librarydocuments" target="_blank">Resource Library</a></div>
                                                    <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/ideation-home" target="_blank">Product Ideas</a></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>        

                                    <a href="https://acumenacademy.brightspace.com/d2l/le/discovery/view/" target="_blank"><div className="dropbtn-academy">Acumen Academy</div></a>            

                                    <div className={IsVizPage ? "divvissible" : "hidden"}><button className="dropbtn-fullscreen" name="fullscreen"><img className="fullscreen" src="/logos/fullscreen.png" onClick={this.handleFullscreen} alt="Full Screen"></img></button></div>
                                </div>
                                }

                                <div className="col"><img className="acumenpoweredbylogo" src="/logos/acumen_powered_by.png" alt="Powered By Acumen"/></div>
                            </div>
                            <div className="row headersecondrow">
                                <div className="col"><Sidebar/></div>
                                <div className="col">
                                    <nav className="navbar navbar-expand-lg navbar-light">                    
                                        <div className="account-menu">
                                                <a className="account-menu-toggle" href="#account-toggle" data-toggle="collapse" aria-expanded="false">
                                                {/*<i className="fas fa-user-circle"></i>*/}
                                                    <span>{username}</span>
                                                    <i className="fas fa-angle-down profilearrow"></i>
                                                </a>
                                                <ul className="collapse list-unstyled" id="account-toggle">
                                                    <li>
                                                        <a href='/profile'>Profile</a>
                                                    </li>
                                                    <li>
                                                        <a href='/profile/password/change'>Change Password</a>
                                                    </li>
                                                    <li>
                                                        <a href='/signout'>Sign Out</a>
                                                    </li>
                                                </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                   
                   

                    {/*<nav className="navbar navbar-expand-lg navbar-light"> */}
                        
                        { /*
                        
                        <a href={this.state.homeUrl || '/'}>
                        <img className="" src={require('../../Images/acumen_full-color-web.png')}  alt="Logo"/>
                        </a>

                        <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                            <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
                            <li className={isAcumenAdmin ? 'hidden nav-item' : 'nav-item'}><a className="nav-link" href="/dashboards">Dashboards</a></li>
                            <li className={isAcumenAdmin ? 'hidden nav-item' : 'nav-item'}><a className="nav-link" href="/visualizations">Visualizations</a></li>
                            <li className={isAcumenAdmin ? 'hidden nav-item' : 'nav-item'}><a className="nav-link" href="/resources">Resources</a></li>
                            <li className={isCustomerAdmin ? 'nav-item' : 'hidden nav-item'}><a className="nav-link" href={"/admin/users/" + this.profile.CustomerId()}>Users</a></li>
                            <li className={isAcumenAdmin ? 'nav-item' : 'hidden nav-item'}><a className="nav-link" href="/admin/customers">Customers</a></li> 
                            <li className={isAcumenAdmin ? 'nav-item' : 'hidden nav-item'}><a className="nav-link" href={"/admin/users/" + config.AcumenAdminName}>System Admin</a></li> 
                            <li className={isAuthenticated ? 'nav-item' : 'hidden nav-item'}><a className="nav-link" href="/signout">Sign Out</a></li> 
                        </ul>
                        */}  
                        {/*
                        <div className="account-menu">
                            <a className="account-menu-toggle" href="#account-toggle" data-toggle="collapse" aria-expanded="false">                               
                                <span>{username}</span>
                                <i className="fas fa-angle-down"></i>
                            </a>
                            <ul className="collapse list-unstyled" id="account-toggle">
                                <li>
                                    <a href='/profile'>Profile</a>
                                </li>
                                <li>
                                    <a href='/profile/password/change'>Change Password</a>
                                </li>
                                <li>
                                    <a href='/signout'>Sign Out</a>
                                </li>
                            </ul>
                        </div>
                        */}                      
                    {/*</nav>*/}
                </header>;
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/Components/Shared/Header.js